import { ILoggerMeasurement } from '@app/api/interfaces/logger-measurement.interface';
import { LeakScoreStatus } from '@app/core/enums/leak-score-status.enum';
import { LeakScoreMode } from '@app/core/enums/leak-score-mode.enum';
import dayjs from 'dayjs';
import { SoundSignalType } from '@app/core/enums/sound-signal-type.enum';

export const measStartTime1 = dayjs('2025-03-12').add(2, 'hour').toISOString();
export const measStartTime2 = dayjs('2025-03-12').add(5, 'hour').toISOString();
export const measStartTime3 = dayjs('2025-03-12').add(5, 'hour').add(12, 'minute').toISOString();
export const soundSignalTime1 = dayjs('2025-03-12').add(5, 'hour').toISOString();
export const soundSignalTime2 = dayjs('2025-03-12').add(7, 'hour').toISOString();

export const loggerMeasurementMockData: ILoggerMeasurement[] = [
  {
    id: 'lm1',
    leakScore: 54,
    leakScoreMode: LeakScoreMode.AiPredictor,
    leakScoreStatus: LeakScoreStatus.Warn,
    soundSignalUrl: 'ss1',
    soundSignalId: 'ss_id_1',
    deploymentId: 'ld00001',
    lowestNoiseDecibel: 5.1,
    spread: 4.4,
    measStartTime: measStartTime2,
    soundSignalStartAt: soundSignalTime2,
    assetId: 'asset1',
    comment: {
      content: '_some comment',
      author: 'John Doe',
      modifiedAt: dayjs('2025-03-12').toISOString(),
    },
    envNoiseDecibel: 4.3,
    soundSignalSamplingFrequency: 4000,
    ls1_4: 12.5,
    dBover: 3.2,
    fRated1_4: 125.0,
    fPeaks1_4: 140.0,
    dyn1_4: 27.5,
    periodicity: 0.85,
    facCorrels: 0.92,
    l1_1_4: 5.1,
    l3_1_4: 8.3,
    l4_1_4: 9.7,
    l5_1_4: 11.2,
    l6_1_4: 13.4,
    l7_1_4: 15.6,
    ccount: 42,
    spectrumStdDev: 2.18,
  },
  {
    id: 'lm1a',
    leakScore: 90,
    leakScoreMode: LeakScoreMode.AiPredictor,
    leakScoreStatus: LeakScoreStatus.Critical,
    soundSignalUrl: 'ss1',
    soundSignalId: 'ss_id_1',
    deploymentId: 'ld00001',
    lowestNoiseDecibel: 8.2,
    spread: 4.4,
    measStartTime: measStartTime1,
    soundSignalStartAt: soundSignalTime1,
    assetId: 'asset1',
    comment: {
      content: '_some comment',
      author: 'John Doe',
      modifiedAt: dayjs('2025-03-12').toISOString(),
    },
    envNoiseDecibel: 4.3,
  },
  {
    id: 'lm2',
    leakScoreMode: LeakScoreMode.Legacy,
    leakScoreStatus: LeakScoreStatus.Normal,
    deploymentId: 'ld00002',
    lowestNoiseDecibel: 5.2,
    spread: 4.6,
    measStartTime: measStartTime2,
    soundSignalStartAt: soundSignalTime2,
    assetId: 'asset1',
    envNoiseDecibel: 6.3,
  },
  {
    id: 'lm3',
    leakScore: 10,
    leakScoreMode: LeakScoreMode.AiPredictor,
    leakScoreStatus: LeakScoreStatus.Normal,
    soundSignalUrl: 'ss1',
    soundSignalId: 'ss_id_1',
    deploymentId: 'ld00003',
    lowestNoiseDecibel: 5.2,
    spread: 4.6,
    measStartTime: measStartTime2,
    soundSignalStartAt: soundSignalTime2,
    assetId: 'asset1',
    comment: {
      content: 'some comment',
      author: 'John Doe',
      modifiedAt: dayjs('2025-03-12').toISOString(),
    },
    envNoiseDecibel: 4.2,
  },
  {
    id: 'lm4',
    leakScore: 64,
    leakScoreMode: LeakScoreMode.AiPredictor,
    leakScoreStatus: LeakScoreStatus.Warn,
    soundSignalUrl: 'ss1',
    soundSignalId: 'ss_id_1',
    deploymentId: 'ld00004',
    lowestNoiseDecibel: 5.2,
    spread: 4.6,
    measStartTime: measStartTime2,
    soundSignalStartAt: soundSignalTime2,
    assetId: 'asset1',
    comment: {
      content: 'some comment',
      author: 'John Doe',
      modifiedAt: dayjs('2025-03-12').toISOString(),
    },
  },
  {
    id: 'lm5',
    leakScore: 48,
    leakScoreMode: LeakScoreMode.AiPredictor,
    leakScoreStatus: LeakScoreStatus.Warn,
    soundSignalUrl: 'ss1',
    soundSignalId: 'ss_id_1',
    deploymentId: 'ld00005',
    lowestNoiseDecibel: 5.2,
    spread: 4.6,
    measStartTime: measStartTime2,
    soundSignalStartAt: soundSignalTime2,
    assetId: 'asset1',
    comment: {
      content: 'some comment',
      author: 'John Doe',
      modifiedAt: dayjs('2025-03-12').toISOString(),
    },
    envNoiseDecibel: 5.7,
  },
  {
    id: 'lm6',
    leakScore: 22,
    leakScoreMode: LeakScoreMode.AiPredictor,
    leakScoreStatus: LeakScoreStatus.Normal,
    soundSignalUrl: 'ss1',
    soundSignalId: 'ss_id_1',
    deploymentId: 'ld00006',
    lowestNoiseDecibel: 5.2,
    spread: 4.6,
    measStartTime: measStartTime2,
    soundSignalStartAt: soundSignalTime2,
    assetId: 'asset1',
    comment: {
      content: 'some comment',
      author: 'John Doe',
      modifiedAt: dayjs('2025-03-12').toISOString(),
    },
    envNoiseDecibel: 1.1,
  },
  {
    id: 'lm7',
    leakScore: 50,
    leakScoreMode: LeakScoreMode.AiPredictor,
    leakScoreStatus: LeakScoreStatus.Warn,
    soundSignalUrl: 'ss1',
    soundSignalId: 'ss_id_1',
    deploymentId: 'ld00007',
    lowestNoiseDecibel: 5.2,
    spread: 4.6,
    measStartTime: measStartTime2,
    soundSignalStartAt: soundSignalTime2,
    assetId: 'asset1',
    comment: {
      content: 'some comment',
      author: 'John Doe',
      modifiedAt: dayjs('2025-03-12').toISOString(),
    },
  },
  {
    id: 'lm8',
    leakScore: 75,
    leakScoreMode: LeakScoreMode.AiPredictor,
    leakScoreStatus: LeakScoreStatus.Critical,
    soundSignalUrl: 'ss1',
    soundSignalId: 'ss_id_1',
    deploymentId: 'ld00008',
    lowestNoiseDecibel: 5.2,
    spread: 4.6,
    measStartTime: measStartTime2,
    soundSignalStartAt: soundSignalTime2,
    assetId: 'asset1',
    comment: {
      content: 'some comment',
      author: 'John Doe',
      modifiedAt: dayjs('2025-03-12').toISOString(),
    },
    envNoiseDecibel: 7.4,
  },
  {
    id: 'lm9',
    leakScore: 13,
    leakScoreMode: LeakScoreMode.AiPredictor,
    leakScoreStatus: LeakScoreStatus.Normal,
    soundSignalUrl: 'ss1',
    soundSignalId: 'ss_id_1',
    deploymentId: 'ld00009',
    lowestNoiseDecibel: 5.2,
    spread: 4.6,
    measStartTime: measStartTime2,
    soundSignalStartAt: soundSignalTime2,
    assetId: 'asset1',
    comment: {
      content: 'some comment',
      author: 'John Doe',
      modifiedAt: dayjs('2025-03-12').toISOString(),
    },
    envNoiseDecibel: 6.1,
  },
  {
    id: 'lm10',
    leakScore: 98,
    leakScoreMode: LeakScoreMode.AiPredictor,
    leakScoreStatus: LeakScoreStatus.Critical,
    soundSignalUrl: 'ss1',
    soundSignalId: 'ss_id_1',
    deploymentId: 'ld00010',
    lowestNoiseDecibel: 5.2,
    spread: 4.6,
    measStartTime: measStartTime3,
    assetId: 'asset1',
    comment: {
      content: 'some comment',
      author: 'John Doe',
      modifiedAt: dayjs('2025-03-12').toISOString(),
    },
    envNoiseDecibel: 3.3,
  },
  {
    id: 'lm11',
    leakScore: 0,
    leakScoreMode: LeakScoreMode.Legacy,
    leakScoreStatus: LeakScoreStatus.Warn,
    soundSignalUrl: 'ss1',
    soundSignalId: 'ss_id_1',
    deploymentId: 'ld00011',
    lowestNoiseDecibel: 5.2,
    spread: 4.6,
    measStartTime: measStartTime1,
    soundSignalStartAt: soundSignalTime1,
    assetId: 'asset1',
    comment: {
      content: 'some comment',
      author: 'John Doe',
      modifiedAt: dayjs('2025-03-12').toISOString(),
    },
  },
  {
    id: 'lm12',
    leakScore: 24,
    leakScoreMode: LeakScoreMode.AiPredictor,
    leakScoreStatus: LeakScoreStatus.Normal,
    soundSignalUrl: 'ss1',
    soundSignalId: 'ss_id_1',
    deploymentId: 'ld00012',
    lowestNoiseDecibel: 5.2,
    spread: 4.6,
    measStartTime: measStartTime2,
    soundSignalStartAt: soundSignalTime2,
    assetId: 'asset1',
    comment: {
      content: 'some comment',
      author: 'John Doe',
      modifiedAt: dayjs('2025-03-12').toISOString(),
    },
    envNoiseDecibel: 5.9,
  },
  {
    id: 'lm13',
    leakScore: 89,
    leakScoreMode: LeakScoreMode.AiPredictor,
    leakScoreStatus: LeakScoreStatus.Critical,
    soundSignalUrl: 'ss1',
    soundSignalId: 'ss_id_1',
    deploymentId: 'ld00013',
    lowestNoiseDecibel: 5.2,
    spread: 4.6,
    measStartTime: measStartTime2,
    soundSignalStartAt: soundSignalTime2,
    assetId: 'asset1',
    comment: {
      content: 'some comment',
      author: 'John Doe',
      modifiedAt: dayjs('2025-03-12').toISOString(),
    },
  },
  {
    id: 'lm14',
    leakScore: 88,
    leakScoreMode: LeakScoreMode.AiPredictor,
    leakScoreStatus: LeakScoreStatus.Critical,
    soundSignalUrl: 'ss1',
    soundSignalId: 'ss_id_1',
    deploymentId: 'ld00014',
    lowestNoiseDecibel: 5.2,
    spread: 4.6,
    measStartTime: measStartTime2,
    soundSignalStartAt: soundSignalTime2,
    assetId: 'asset1',
    comment: {
      content: 'some comment',
      author: 'John Doe',
      modifiedAt: dayjs('2025-03-12').toISOString(),
    },
  },
  {
    id: 'lm15',
    leakScore: 79,
    leakScoreMode: LeakScoreMode.AiPredictor,
    leakScoreStatus: LeakScoreStatus.Critical,
    soundSignalUrl: 'ss1',
    soundSignalId: 'ss_id_1',
    deploymentId: 'ld00015',
    lowestNoiseDecibel: 5.2,
    spread: 4.6,
    measStartTime: measStartTime2,
    soundSignalStartAt: soundSignalTime2,
    assetId: 'asset1',
    comment: {
      content: 'some comment',
      author: 'John Doe',
      modifiedAt: dayjs('2025-03-12').toISOString(),
    },
  },
  {
    id: 'lm16',
    leakScore: 66,
    leakScoreMode: LeakScoreMode.AiPredictor,
    leakScoreStatus: LeakScoreStatus.Warn,
    soundSignalUrl: 'ss1',
    soundSignalId: 'ss_id_1',
    deploymentId: 'ld00016',
    lowestNoiseDecibel: 5.2,
    spread: 4.6,
    measStartTime: measStartTime2,
    soundSignalStartAt: soundSignalTime2,
    assetId: 'asset1',
    comment: {
      content: 'some comment',
      author: 'John Doe',
      modifiedAt: dayjs('2025-03-12').toISOString(),
    },
    envNoiseDecibel: 4.8,
  },
  {
    id: 'lm17',
    leakScore: 96,
    leakScoreMode: LeakScoreMode.AiPredictor,
    leakScoreStatus: LeakScoreStatus.Critical,
    soundSignalUrl: 'ss1',
    soundSignalId: 'ss_id_1',
    deploymentId: 'ld00017',
    lowestNoiseDecibel: 5.2,
    spread: 4.6,
    measStartTime: measStartTime2,
    soundSignalStartAt: soundSignalTime2,
    assetId: 'asset1',
    comment: {
      content: 'some comment',
      author: 'John Doe',
      modifiedAt: dayjs('2025-03-12').toISOString(),
    },
    envNoiseDecibel: 2.6,
  },
  {
    id: 'lm36',
    leakScore: 10,
    leakScoreMode: LeakScoreMode.AiPredictor,
    leakScoreStatus: LeakScoreStatus.Normal,
    soundSignalUrl: 'ss1',
    soundSignalId: 'ss_id_1',
    deploymentId: 'ld000036',
    lowestNoiseDecibel: 5.2,
    spread: 4.6,
    measStartTime: measStartTime2,
    soundSignalStartAt: soundSignalTime2,
    assetId: 'asset1',
    comment: {
      content: 'some comment',
      author: 'John Doe',
      modifiedAt: dayjs('2025-03-12').toISOString(),
    },
    envNoiseDecibel: 4.2,
  },
  // loggers for displaying different types and statuses
  {
    id: 'lm1test',
    leakScore: 14,
    leakScoreMode: LeakScoreMode.AiPredictor,
    leakScoreStatus: LeakScoreStatus.Normal,
    soundSignalUrl: 'ss1',
    soundSignalId: 'ss_id_1',
    deploymentId: 'ld00001test',
    lowestNoiseDecibel: 5.2,
    spread: 4.6,
    measStartTime: dayjs('2025-03-12').add(5, 'hour').toISOString(),
    soundSignalStartAt: dayjs('2025-03-12').toISOString(),
    assetId: 'asset1',
    comment: {
      content: 'some comment',
      author: 'John Doe',
      modifiedAt: dayjs('2025-03-12').toISOString(),
    },
    envNoiseDecibel: 4.3,
  },
  {
    id: 'lm2test',
    leakScore: 54,
    leakScoreMode: LeakScoreMode.AiPredictor,
    leakScoreStatus: LeakScoreStatus.Warn,
    soundSignalUrl: 'ss1',
    soundSignalId: 'ss_id_1',
    deploymentId: 'ld00002test',
    lowestNoiseDecibel: 5.2,
    spread: 4.6,
    measStartTime: dayjs('2025-03-12').add(5, 'hour').toISOString(),
    soundSignalStartAt: dayjs('2025-03-12').toISOString(),
    assetId: 'asset1',
    comment: {
      content: 'some comment',
      author: 'John Doe',
      modifiedAt: dayjs('2025-03-12').toISOString(),
    },
    envNoiseDecibel: 4.3,
  },
  {
    id: 'lm3test',
    leakScore: 94,
    leakScoreMode: LeakScoreMode.AiPredictor,
    leakScoreStatus: LeakScoreStatus.Critical,
    soundSignalUrl: 'ss1',
    soundSignalId: 'ss_id_1',
    deploymentId: 'ld00003test',
    lowestNoiseDecibel: 5.2,
    spread: 4.6,
    measStartTime: dayjs('2025-03-12').add(5, 'hour').toISOString(),
    soundSignalStartAt: dayjs('2025-03-12').toISOString(),
    assetId: 'asset1',
    comment: {
      content: 'some comment',
      author: 'John Doe',
      modifiedAt: dayjs('2025-03-12').toISOString(),
    },
    envNoiseDecibel: 4.3,
  },
  {
    id: 'lm4test',
    leakScore: 2,
    leakScoreMode: LeakScoreMode.AiPredictor,
    leakScoreStatus: LeakScoreStatus.Neutral,
    soundSignalUrl: 'ss1',
    soundSignalId: 'ss_id_1',
    deploymentId: 'ld00004test',
    lowestNoiseDecibel: 5.2,
    spread: 4.6,
    measStartTime: dayjs('2025-03-12').add(5, 'hour').toISOString(),
    soundSignalStartAt: dayjs('2025-03-12').toISOString(),
    assetId: 'asset1',
    comment: {
      content: 'some comment',
      author: 'John Doe',
      modifiedAt: dayjs('2025-03-12').toISOString(),
    },
    envNoiseDecibel: 4.3,
  },
  {
    id: 'lm5test',
    leakScore: 21,
    leakScoreMode: LeakScoreMode.AiPredictor,
    leakScoreStatus: LeakScoreStatus.Normal,
    soundSignalUrl: 'ss1',
    soundSignalId: 'ss_id_1',
    deploymentId: 'ld00005test',
    lowestNoiseDecibel: 5.2,
    spread: 4.6,
    measStartTime: dayjs('2025-03-12').add(5, 'hour').toISOString(),
    soundSignalStartAt: dayjs('2025-03-12').toISOString(),
    assetId: 'asset1',
    comment: {
      content: 'some comment',
      author: 'John Doe',
      modifiedAt: dayjs('2025-03-12').toISOString(),
    },
    envNoiseDecibel: 4.3,
  },
  {
    id: 'lm6test',
    leakScore: 57,
    leakScoreMode: LeakScoreMode.AiPredictor,
    leakScoreStatus: LeakScoreStatus.Warn,
    soundSignalUrl: 'ss1',
    soundSignalId: 'ss_id_1',
    deploymentId: 'ld00006test',
    lowestNoiseDecibel: 5.2,
    spread: 4.6,
    measStartTime: dayjs('2025-03-12').add(5, 'hour').toISOString(),
    soundSignalStartAt: dayjs('2025-03-12').toISOString(),
    assetId: 'asset1',
    comment: {
      content: 'some comment',
      author: 'John Doe',
      modifiedAt: dayjs('2025-03-12').toISOString(),
    },
    envNoiseDecibel: 4.3,
  },
  {
    id: 'lm7test',
    leakScore: 87,
    leakScoreMode: LeakScoreMode.AiPredictor,
    leakScoreStatus: LeakScoreStatus.Critical,
    soundSignalUrl: 'ss1',
    soundSignalId: 'ss_id_1',
    deploymentId: 'ld00007test',
    lowestNoiseDecibel: 5.2,
    spread: 4.6,
    measStartTime: dayjs('2025-03-12').add(5, 'hour').toISOString(),
    soundSignalStartAt: dayjs('2025-03-12').toISOString(),
    assetId: 'asset1',
    comment: {
      content: 'some comment',
      author: 'John Doe',
      modifiedAt: dayjs('2025-03-12').toISOString(),
    },
    envNoiseDecibel: 4.3,
  },
  {
    id: 'lm8test',
    leakScore: 0,
    leakScoreMode: LeakScoreMode.AiPredictor,
    leakScoreStatus: LeakScoreStatus.Neutral,
    soundSignalUrl: 'ss1',
    soundSignalId: 'ss_id_1',
    deploymentId: 'ld00008test',
    lowestNoiseDecibel: 5.2,
    spread: 4.6,
    measStartTime: dayjs('2025-03-12').add(5, 'hour').toISOString(),
    soundSignalStartAt: dayjs('2025-03-12').toISOString(),
    assetId: 'asset1',
    comment: {
      content: 'some comment',
      author: 'John Doe',
      modifiedAt: dayjs('2025-03-12').toISOString(),
    },
    envNoiseDecibel: 4.3,
  },
  {
    id: 'lm9test',
    leakScore: 31,
    leakScoreMode: LeakScoreMode.AiPredictor,
    leakScoreStatus: LeakScoreStatus.Normal,
    soundSignalUrl: 'ss1',
    soundSignalId: 'ss_id_1',
    deploymentId: 'ld00009test',
    lowestNoiseDecibel: 5.2,
    spread: 4.6,
    measStartTime: dayjs('2025-03-12').add(5, 'hour').toISOString(),
    soundSignalStartAt: dayjs('2025-03-12').toISOString(),
    assetId: 'asset1',
    comment: {
      content: 'some comment',
      author: 'John Doe',
      modifiedAt: dayjs('2025-03-12').toISOString(),
    },
    envNoiseDecibel: 4.3,
  },
  {
    id: 'lm10test',
    leakScore: 48,
    leakScoreMode: LeakScoreMode.AiPredictor,
    leakScoreStatus: LeakScoreStatus.Warn,
    soundSignalUrl: 'ss1',
    soundSignalId: 'ss_id_1',
    deploymentId: 'ld00010test',
    lowestNoiseDecibel: 5.2,
    spread: 4.6,
    measStartTime: dayjs('2025-03-12').add(5, 'hour').toISOString(),
    soundSignalStartAt: dayjs('2025-03-12').toISOString(),
    assetId: 'asset1',
    comment: {
      content: 'some comment',
      author: 'John Doe',
      modifiedAt: dayjs('2025-03-12').toISOString(),
    },
    envNoiseDecibel: 4.3,
  },
  {
    id: 'lm11test',
    leakScore: 73,
    leakScoreMode: LeakScoreMode.AiPredictor,
    leakScoreStatus: LeakScoreStatus.Critical,
    soundSignalUrl: 'ss1',
    soundSignalId: 'ss_id_1',
    deploymentId: 'ld00011test',
    lowestNoiseDecibel: 5.2,
    spread: 4.6,
    measStartTime: dayjs('2025-03-12').add(5, 'hour').toISOString(),
    soundSignalStartAt: dayjs('2025-03-12').toISOString(),
    assetId: 'asset1',
    comment: {
      content: 'some comment',
      author: 'John Doe',
      modifiedAt: dayjs('2025-03-12').toISOString(),
    },
    envNoiseDecibel: 4.3,
  },
  {
    id: 'lm12test',
    leakScore: 2,
    leakScoreMode: LeakScoreMode.Legacy,
    leakScoreStatus: LeakScoreStatus.Neutral,
    soundSignalUrl: 'ss1',
    soundSignalId: 'ss_id_1',
    deploymentId: 'ld00012test',
    lowestNoiseDecibel: 5.2,
    spread: 4.6,
    measStartTime: dayjs('2025-03-12').add(5, 'hour').toISOString(),
    soundSignalStartAt: dayjs('2025-03-12').toISOString(),
    assetId: 'asset1',
    comment: {
      content: 'some comment',
      author: 'John Doe',
      modifiedAt: dayjs('2025-03-12').toISOString(),
    },
    envNoiseDecibel: 4.3,
  },
  {
    id: 'lm13test',
    leakScore: 25,
    leakScoreMode: LeakScoreMode.AiPredictor,
    leakScoreStatus: LeakScoreStatus.Normal,
    soundSignalUrl: 'ss1',
    soundSignalId: 'ss_id_1',
    deploymentId: 'ld00013test',
    lowestNoiseDecibel: 5.2,
    spread: 4.6,
    measStartTime: dayjs('2025-03-12').add(5, 'hour').toISOString(),
    soundSignalStartAt: dayjs('2025-03-12').toISOString(),
    assetId: 'asset1',
    comment: {
      content: 'some comment',
      author: 'John Doe',
      modifiedAt: dayjs('2025-03-12').toISOString(),
    },
    envNoiseDecibel: 4.3,
  },
  {
    id: 'lm14test',
    leakScore: 54,
    leakScoreMode: LeakScoreMode.AiPredictor,
    leakScoreStatus: LeakScoreStatus.Warn,
    soundSignalUrl: 'ss1',
    soundSignalId: 'ss_id_1',
    deploymentId: 'ld00014test',
    lowestNoiseDecibel: 5.2,
    spread: 4.6,
    measStartTime: dayjs('2025-03-12').add(5, 'hour').toISOString(),
    soundSignalStartAt: dayjs('2025-03-12').toISOString(),
    assetId: 'asset1',
    comment: {
      content: 'some comment',
      author: 'John Doe',
      modifiedAt: dayjs('2025-03-12').toISOString(),
    },
    envNoiseDecibel: 4.3,
  },
  {
    id: 'lm15test',
    leakScore: 99,
    leakScoreMode: LeakScoreMode.AiPredictor,
    leakScoreStatus: LeakScoreStatus.Critical,
    soundSignalUrl: 'ss1',
    soundSignalId: 'ss_id_1',
    deploymentId: 'ld00015test',
    lowestNoiseDecibel: 5.2,
    spread: 4.6,
    measStartTime: dayjs('2025-03-12').add(5, 'hour').toISOString(),
    soundSignalStartAt: dayjs('2025-03-12').toISOString(),
    assetId: 'asset1',
    comment: {
      content: 'some comment',
      author: 'John Doe',
      modifiedAt: dayjs('2025-03-12').toISOString(),
    },
    envNoiseDecibel: 4.3,
  },
  {
    id: 'lm16test',
    leakScore: 0,
    leakScoreMode: LeakScoreMode.Legacy,
    leakScoreStatus: LeakScoreStatus.Neutral,
    soundSignalUrl: 'ss1',
    soundSignalId: 'ss_id_1',
    deploymentId: 'ld00016test',
    lowestNoiseDecibel: 5.2,
    spread: 4.6,
    measStartTime: dayjs('2025-03-12').add(5, 'hour').toISOString(),
    soundSignalStartAt: dayjs('2025-03-12').toISOString(),
    assetId: 'asset1',
    comment: {
      content: 'some comment',
      author: 'John Doe',
      modifiedAt: dayjs('2025-03-12').toISOString(),
    },
    envNoiseDecibel: 4.3,
  },
  {
    id: 'lm17test',
    leakScore: 20,
    leakScoreMode: LeakScoreMode.AiPredictor,
    leakScoreStatus: LeakScoreStatus.Normal,
    soundSignalUrl: 'ss1',
    soundSignalId: 'ss_id_1',
    deploymentId: 'ld00017test',
    lowestNoiseDecibel: 5.2,
    spread: 4.6,
    measStartTime: dayjs('2025-03-12').add(5, 'hour').toISOString(),
    soundSignalStartAt: dayjs('2025-03-12').toISOString(),
    assetId: 'asset1',
    comment: {
      content: 'some comment',
      author: 'John Doe',
      modifiedAt: dayjs('2025-03-12').toISOString(),
    },
    envNoiseDecibel: 4.3,
  },
  {
    id: 'lm18test',
    leakScore: 61,
    leakScoreMode: LeakScoreMode.AiPredictor,
    leakScoreStatus: LeakScoreStatus.Warn,
    soundSignalUrl: 'ss1',
    soundSignalId: 'ss_id_1',
    deploymentId: 'ld00018test',
    lowestNoiseDecibel: 5.2,
    spread: 4.6,
    measStartTime: dayjs('2025-03-12').add(5, 'hour').toISOString(),
    soundSignalStartAt: dayjs('2025-03-12').toISOString(),
    assetId: 'asset1',
    comment: {
      content: 'some comment',
      author: 'John Doe',
      modifiedAt: dayjs('2025-03-12').toISOString(),
    },
    envNoiseDecibel: 4.3,
  },
  {
    id: 'lm19test',
    leakScore: 100,
    leakScoreMode: LeakScoreMode.AiPredictor,
    leakScoreStatus: LeakScoreStatus.Critical,
    soundSignalUrl: 'ss1',
    soundSignalId: 'ss_id_1',
    deploymentId: 'ld00019test',
    lowestNoiseDecibel: 5.2,
    spread: 4.6,
    measStartTime: dayjs('2025-03-12').add(5, 'hour').toISOString(),
    soundSignalStartAt: dayjs('2025-03-12').toISOString(),
    assetId: 'asset1',
    comment: {
      content: 'some comment',
      author: 'John Doe',
      modifiedAt: dayjs('2025-03-12').toISOString(),
    },
    envNoiseDecibel: 4.3,
  },
  {
    id: 'lm20test',
    leakScoreMode: LeakScoreMode.Legacy,
    leakScoreStatus: LeakScoreStatus.Neutral,
    deploymentId: 'ld00020test',
    lowestNoiseDecibel: 5.2,
    spread: 4.6,
    measStartTime: dayjs('2025-03-12').add(5, 'hour').toISOString(),
    soundSignalStartAt: dayjs('2025-03-12').toISOString(),
    assetId: 'asset1',
    comment: {
      content: 'some comment',
      author: 'John Doe',
      modifiedAt: dayjs('2025-03-12').toISOString(),
    },
    envNoiseDecibel: 4.3,
  },
  {
    id: 'lm21test',
    leakScore: 4,
    leakScoreMode: LeakScoreMode.AiPredictor,
    leakScoreStatus: LeakScoreStatus.Neutral,
    soundSignalUrl: 'ss1',
    soundSignalId: 'ss_id_1',
    deploymentId: 'ld00021test',
    lowestNoiseDecibel: 5.2,
    spread: 4.6,
    measStartTime: dayjs('2025-03-12').add(5, 'hour').toISOString(),
    soundSignalStartAt: dayjs('2025-03-12').toISOString(),
    assetId: 'asset1',
    comment: {
      content: 'some comment',
      author: 'John Doe',
      modifiedAt: dayjs('2025-03-12').toISOString(),
    },
    envNoiseDecibel: 4.3,
  },
  {
    id: 'lm22test',
    leakScore: 11,
    leakScoreMode: LeakScoreMode.AiPredictor,
    leakScoreStatus: LeakScoreStatus.Normal,
    soundSignalUrl: 'ss1',
    soundSignalId: 'ss_id_1',
    deploymentId: 'ld00022test',
    lowestNoiseDecibel: 5.2,
    spread: 4.6,
    measStartTime: dayjs('2025-03-12').add(5, 'hour').toISOString(),
    soundSignalStartAt: dayjs('2025-03-12').toISOString(),
    assetId: 'asset1',
    comment: {
      content: 'some comment',
      author: 'John Doe',
      modifiedAt: dayjs('2025-03-12').toISOString(),
    },
    envNoiseDecibel: 4.3,
  },
  {
    id: 'lm23test',
    leakScore: 0,
    leakScoreMode: LeakScoreMode.AiPredictor,
    leakScoreStatus: LeakScoreStatus.Neutral,
    soundSignalUrl: 'ss1',
    soundSignalId: 'ss_id_1',
    deploymentId: 'ld00023test',
    lowestNoiseDecibel: 5.2,
    spread: 4.6,
    measStartTime: dayjs('2025-03-12').add(5, 'hour').toISOString(),
    soundSignalStartAt: dayjs('2025-03-12').toISOString(),
    assetId: 'asset1',
    comment: {
      content: 'some comment',
      author: 'John Doe',
      modifiedAt: dayjs('2025-03-12').toISOString(),
    },
    envNoiseDecibel: 4.3,
  },
  {
    id: 'lm24test',
    leakScore: 24,
    leakScoreMode: LeakScoreMode.AiPredictor,
    leakScoreStatus: LeakScoreStatus.Normal,
    soundSignalUrl: 'ss1',
    soundSignalId: 'ss_id_1',
    deploymentId: 'ld00024test',
    lowestNoiseDecibel: 5.2,
    spread: 4.6,
    measStartTime: dayjs('2025-03-12').add(5, 'hour').toISOString(),
    soundSignalStartAt: dayjs('2025-03-12').toISOString(),
    assetId: 'asset1',
    comment: {
      content: 'some comment',
      author: 'John Doe',
      modifiedAt: dayjs('2025-03-12').toISOString(),
    },
    envNoiseDecibel: 4.3,
  },
  {
    id: 'lm25test',
    leakScore: 28,
    leakScoreMode: LeakScoreMode.AiPredictor,
    leakScoreStatus: LeakScoreStatus.Normal,
    soundSignalUrl: 'ss1',
    soundSignalId: 'ss_id_1',
    deploymentId: 'ld00025test',
    lowestNoiseDecibel: 5.2,
    spread: 4.6,
    measStartTime: dayjs('2025-03-12').add(5, 'hour').toISOString(),
    soundSignalStartAt: dayjs('2025-03-12').toISOString(),
    assetId: 'asset1',
    comment: {
      content: 'some comment',
      author: 'John Doe',
      modifiedAt: dayjs('2025-03-12').toISOString(),
    },
    envNoiseDecibel: 4.3,
  },
  {
    id: 'lm26test',
    leakScore: 41,
    leakScoreMode: LeakScoreMode.AiPredictor,
    leakScoreStatus: LeakScoreStatus.Warn,
    soundSignalUrl: 'ss1',
    soundSignalId: 'ss_id_1',
    deploymentId: 'ld00026test',
    lowestNoiseDecibel: 5.2,
    spread: 4.6,
    measStartTime: dayjs('2025-03-12').add(5, 'hour').toISOString(),
    soundSignalStartAt: dayjs('2025-03-12').toISOString(),
    assetId: 'asset1',
    comment: {
      content: 'some comment',
      author: 'John Doe',
      modifiedAt: dayjs('2025-03-12').toISOString(),
    },
    envNoiseDecibel: 4.3,
  },
  {
    id: 'lm27test',
    leakScore: 89,
    leakScoreMode: LeakScoreMode.AiPredictor,
    leakScoreStatus: LeakScoreStatus.Critical,
    soundSignalUrl: 'ss1',
    soundSignalId: 'ss_id_1',
    deploymentId: 'ld00027test',
    lowestNoiseDecibel: 5.2,
    spread: 4.6,
    measStartTime: dayjs('2025-03-12').add(5, 'hour').toISOString(),
    soundSignalStartAt: dayjs('2025-03-12').toISOString(),
    assetId: 'asset1',
    comment: {
      content: 'some comment',
      author: 'John Doe',
      modifiedAt: dayjs('2025-03-12').toISOString(),
    },
    envNoiseDecibel: 4.3,
  },
  {
    id: 'lm28test',
    leakScore: 3,
    leakScoreMode: LeakScoreMode.AiPredictor,
    leakScoreStatus: LeakScoreStatus.Neutral,
    soundSignalUrl: 'ss1',
    soundSignalId: 'ss_id_1',
    deploymentId: 'ld00028test',
    lowestNoiseDecibel: 5.2,
    spread: 4.6,
    measStartTime: dayjs('2025-03-12').add(5, 'hour').toISOString(),
    soundSignalStartAt: dayjs('2025-03-12').toISOString(),
    assetId: 'asset1',
    comment: {
      content: 'some comment',
      author: 'John Doe',
      modifiedAt: dayjs('2025-03-12').toISOString(),
    },
    envNoiseDecibel: 4.3,
  },
  {
    id: 'lm29test',
    leakScore: 79,
    leakScoreMode: LeakScoreMode.AiPredictor,
    leakScoreStatus: LeakScoreStatus.Critical,
    soundSignalUrl: 'ss1',
    soundSignalId: 'ss_id_1',
    deploymentId: 'ld00029test',
    lowestNoiseDecibel: 5.2,
    spread: 4.6,
    measStartTime: dayjs('2025-03-12').add(5, 'hour').toISOString(),
    soundSignalStartAt: dayjs('2025-03-12').toISOString(),
    assetId: 'asset1',
    comment: {
      content: 'some comment',
      author: 'John Doe',
      modifiedAt: dayjs('2025-03-12').toISOString(),
    },
    envNoiseDecibel: 4.3,
  },
  {
    id: 'lm30test',
    leakScore: 52,
    leakScoreMode: LeakScoreMode.Legacy,
    leakScoreStatus: LeakScoreStatus.Warn,
    soundSignalUrl: 'ss1',
    soundSignalId: 'ss_id_1',
    deploymentId: 'ld00030test',
    lowestNoiseDecibel: 5.2,
    spread: 4.6,
    measStartTime: dayjs('2025-03-12').add(5, 'hour').toISOString(),
    soundSignalStartAt: dayjs('2025-03-12').toISOString(),
    assetId: 'asset1',
    comment: {
      content: 'some comment',
      author: 'John Doe',
      modifiedAt: dayjs('2025-03-12').toISOString(),
    },
    envNoiseDecibel: 4.3,
  },
  {
    id: 'lm31test',
    leakScore: 52,
    leakScoreMode: LeakScoreMode.Legacy,
    leakScoreStatus: LeakScoreStatus.Normal,
    soundSignalUrl: 'ss1',
    soundSignalId: 'ss_id_1',
    deploymentId: 'ld00031test',
    lowestNoiseDecibel: 5.2,
    spread: 4.6,
    measStartTime: dayjs('2025-03-12').add(5, 'hour').toISOString(),
    soundSignalStartAt: dayjs('2025-03-12').toISOString(),
    assetId: 'asset1',
    comment: {
      content: 'some comment',
      author: 'John Doe',
      modifiedAt: dayjs('2025-03-12').toISOString(),
    },
    envNoiseDecibel: 4.3,
  },
  {
    id: 'lm32test',
    leakScore: 52,
    leakScoreMode: LeakScoreMode.Legacy,
    leakScoreStatus: LeakScoreStatus.Warn,
    soundSignalUrl: 'ss1',
    soundSignalId: 'ss_id_1',
    deploymentId: 'ld00032test',
    lowestNoiseDecibel: 5.2,
    spread: 4.6,
    measStartTime: dayjs('2025-03-12').add(5, 'hour').toISOString(),
    soundSignalStartAt: dayjs('2025-03-12').toISOString(),
    assetId: 'asset1',
    comment: {
      content: 'some comment',
      author: 'John Doe',
      modifiedAt: dayjs('2025-03-12').toISOString(),
    },
    envNoiseDecibel: 4.3,
  },
  {
    id: 'lm33test',
    leakScore: 52,
    leakScoreMode: LeakScoreMode.Legacy,
    leakScoreStatus: LeakScoreStatus.Critical,
    soundSignalUrl: 'ss1',
    soundSignalId: 'ss_id_1',
    deploymentId: 'ld00033test',
    lowestNoiseDecibel: 5.2,
    spread: 4.6,
    measStartTime: dayjs('2025-03-12').add(5, 'hour').toISOString(),
    soundSignalStartAt: dayjs('2025-03-12').toISOString(),
    assetId: 'asset1',
    comment: {
      content: 'some comment',
      author: 'John Doe',
      modifiedAt: dayjs('2025-03-12').toISOString(),
    },
    envNoiseDecibel: 4.3,
  },
  {
    id: 'lm34test',
    leakScore: 52,
    leakScoreMode: LeakScoreMode.Legacy,
    leakScoreStatus: LeakScoreStatus.Neutral,
    soundSignalUrl: 'ss1',
    soundSignalId: 'ss_id_1',
    deploymentId: 'ld00034test',
    lowestNoiseDecibel: 5.2,
    spread: 4.6,
    measStartTime: dayjs('2025-03-12').add(5, 'hour').toISOString(),
    soundSignalStartAt: dayjs('2025-03-12').toISOString(),
    assetId: 'asset1',
    comment: {
      content: 'some comment',
      author: 'John Doe',
      modifiedAt: dayjs('2025-03-12').toISOString(),
    },
    envNoiseDecibel: 4.3,
  },
  {
    id: 'lm35test',
    leakScore: 52,
    leakScoreMode: LeakScoreMode.Legacy,
    leakScoreStatus: LeakScoreStatus.Normal,
    soundSignalUrl: 'ss1',
    soundSignalId: 'ss_id_1',
    deploymentId: 'ld00035test',
    lowestNoiseDecibel: 5.2,
    spread: 4.6,
    measStartTime: dayjs('2025-03-12').add(5, 'hour').toISOString(),
    soundSignalStartAt: dayjs('2025-03-12').toISOString(),
    assetId: 'asset1',
    comment: {
      content: 'some comment',
      author: 'John Doe',
      modifiedAt: dayjs('2025-03-12').toISOString(),
    },
    envNoiseDecibel: 4.3,
  },
  {
    id: 'lm36test',
    leakScore: 52,
    leakScoreMode: LeakScoreMode.Legacy,
    leakScoreStatus: LeakScoreStatus.Warn,
    soundSignalUrl: 'ss1',
    soundSignalId: 'ss_id_1',
    deploymentId: 'ld00036test',
    lowestNoiseDecibel: 5.2,
    spread: 4.6,
    measStartTime: dayjs('2025-03-12').add(5, 'hour').toISOString(),
    soundSignalStartAt: dayjs('2025-03-12').toISOString(),
    assetId: 'asset1',
    comment: {
      content: 'some comment',
      author: 'John Doe',
      modifiedAt: dayjs('2025-03-12').toISOString(),
    },
    envNoiseDecibel: 4.3,
  },
  {
    id: 'lm37test',
    leakScore: 52,
    leakScoreMode: LeakScoreMode.Legacy,
    leakScoreStatus: LeakScoreStatus.Critical,
    soundSignalUrl: 'ss1',
    soundSignalId: 'ss_id_1',
    deploymentId: 'ld00037test',
    lowestNoiseDecibel: 5.2,
    spread: 4.6,
    measStartTime: dayjs('2025-03-12').add(5, 'hour').toISOString(),
    soundSignalStartAt: dayjs('2025-03-12').toISOString(),
    assetId: 'asset1',
    comment: {
      content: 'some comment',
      author: 'John Doe',
      modifiedAt: dayjs('2025-03-12').toISOString(),
    },
    envNoiseDecibel: 4.3,
  },
  {
    id: 'lm38test',
    leakScore: 52,
    leakScoreMode: LeakScoreMode.Legacy,
    leakScoreStatus: LeakScoreStatus.Neutral,
    soundSignalUrl: 'ss1',
    soundSignalId: 'ss_id_1',
    deploymentId: 'ld00038test',
    lowestNoiseDecibel: 5.2,
    spread: 4.6,
    measStartTime: dayjs('2025-03-12').add(5, 'hour').toISOString(),
    soundSignalStartAt: dayjs('2025-03-12').toISOString(),
    assetId: 'asset1',
    comment: {
      content: 'some comment',
      author: 'John Doe',
      modifiedAt: dayjs('2025-03-12').toISOString(),
    },
    envNoiseDecibel: 4.3,
  },
].map(m => ({
  ...m,
  scPci: 142,
  scPciState: 'Active',
  cellTime: 15,
  syncTime: 8,
  connectionTime: 23,
  soundSignalType: SoundSignalType.ADPCM_4BIT,
  channelAndCell: '2831432345',
  soundSignalSamplingFrequency: m.soundSignalSamplingFrequency ?? 4000,
  ls1_4: m.ls1_4 ?? 12.5,
  dBover: m.dBover ?? 3.2,
  fRated1_4: m.fRated1_4 ?? 125.0,
  fPeaks1_4: m.fPeaks1_4 ?? 140.0,
  dyn1_4: m.dyn1_4 ?? 27.5,
  periodicity: m.periodicity ?? 0.85,
  facCorrels: m.facCorrels ?? 0.92,
  l1_1_4: m.l1_1_4 ?? 5.1,
  l3_1_4: m.l3_1_4 ?? 8.3,
  l4_1_4: m.l4_1_4 ?? 9.7,
  l5_1_4: m.l5_1_4 ?? 11.2,
  l6_1_4: m.l6_1_4 ?? 13.4,
  l7_1_4: m.l7_1_4 ?? 15.6,
  ccount: m.ccount ?? 42,
  spectrumStdDev: m.spectrumStdDev ?? 2.18,
}));
